import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate, Link, useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/serverApiConfig";
import Switch from "react-switch";
import {
    ColourOption,
    colourOptions,
} from "../../Selecteddata/data";
import { Editor } from "react-draft-wysiwyg";
import {
    EditorState,
    convertToRaw,
    ContentState,
    convertFromRaw,
    convertFromHTML,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import Cookies from "js-cookie";
import chroma from "chroma-js";
import Select, { StylesConfig } from "react-select";
import { ReactComponent as TurnoFF } from "../../images/FatX.svg";
import { ReactComponent as TurnOn } from "../../images/base-switch_icon.svg";
import { format } from "date-fns";
import ErrorLoader from "../../components/Loader/SearchBarError";

interface State {
    profileData: any;
    path: any;
}

const EditCandidateProfile = () => {

    const isValidJson = (str: string) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    };

    const navigate = useNavigate();
    const locationObject = useLocation();
    const { profileData, path } = locationObject.state as State;
    const [profile, setProfile] = useState(profileData);
    const [data, setData] = useState({}) as any;
    const [sectorOptions, setSectorOptions] = useState([]) as any;
    const [jobOptions, setJobOptions] = useState([]);
    const [Permis, setPermis] = useState(profile.candidatLicensePermis);
    const [sectors, setSectors] = useState([]);
    const [workExperience, setWorkExperience] = useState(
        profile.candidatExperienceDetails.length > 0
            ? [...profile.candidatExperienceDetails]
            : []
    );
    const [period, setPeriod] = useState("");
    const [location, setLocation] = useState("");
    const [workDoneSample, setWorkDoneSample] = useState("");
    const [jobs, setJobs] = useState([]);
    const params = useParams();

    useEffect(() => {
        fetchCandidat(params.id)
            .then((resData) => {
                if (resData.status) {
                    setProfile(resData.data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [params.id]);

    const fetchCandidat = async (candidatId: any) => {
        return await fetch(
            API_BASE_URL + `getCandidatById/?candidatId=${candidatId}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + Cookies.get("token"),
                },
            }
        )
            .then((resp) => resp.json())
            .then((respData) => respData)
            .catch((err) => err);
    };

    const onContractFormChange = (e: React.ChangeEvent<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | any
    >) => {
        setData((prev) => ({ ...prev, contractId: profile?.candidatContract?._id, contract: { ...data?.contract, [e.target.name]: e.target.value } })) as any;

    }

    const onFormDataChange = (
        e: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | any
        >
    ) => {
        if (e.target.name === "candidatPhoto") {
            console.log("Check photo");
            const fileUploaded = e.target.files[0];
            // setData((prev) => ({ ...prev, [e.target.name]: e.target.files[0] }));
            return;
        }
        if (e.target.name === "candidatActivitySector") {
            return;
        }
        if (e.target.name === "candidatJob") {
            return;
        }

        if (e.target.name === "period") {
            setData((prev) => ({
                ...prev,
                ["candidatExperienceDetails"]: [
                    {
                        period: e.target.value,
                        location: "",
                        workDoneSample: [],
                    },
                ],
            }));
            return;
        }
        if (e.target.name === "location") {
            if (e.target.value) { }
            setData((prev) => ({
                ...prev,
                ["candidatExperienceDetails"]: [
                    {
                        period: "",
                        location: e.target.value,
                        workDoneSample: {},
                    },
                ],
            }));
            return;
        }
        if (e.target.name === "workDoneSample") {
            setData((prev) => ({
                ...prev,
                ["candidatExperienceDetails"]: [
                    {
                        period: "",
                        location: "",
                        workDoneSample: e.target.value,
                    },
                ],
            }));
            return;
        }
        if (e.target.name === 'reasonArchived') {
            setData((prev) => ({
                ...prev,
                ["candidatArchived"]: { reason: e.target.value },
            }));
            return;
        }
        setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSectorChange = (e: any) => {
        if (e.value === "Select A Sector") {
            setJobs([]);
        } else if (e.value !== "") {
            let sectorField = e.value;
            changeSectorSelection(sectorField);
            setData({ ...data, candidatActivitySector: sectorField });
        }
    };

    const changeSectorSelection = async (sec: string) => {
        if (sec) {
            fetchAllJobs(sec);
        }
        let jobN = jobs.map((el) => {
            return { value: el.jobName, label: el.jobName, color: "#FF8B00" };
        });
        setJobOptions([...jobN]);
    };

    const fetchAllJobs = async (sector: string) => {
        return await fetch(API_BASE_URL + `fetchAllJobs/?sector=${sector}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
            },
        })
            .then((resD) => resD.json())
            .then((reD) => {
                setJobs([...reD.data]);
                let jobN = reD.data.map((el) => {
                    return { value: el.jobName, label: el.jobName, color: "#FF8B00" };
                });
                setJobOptions([...jobN]);
            })
            .catch((err) => err);
    };

    useEffect(() => {
        if (profile?.candidatActivitySector) {
            fetchAllJobs(profile.candidatActivitySector);
        }
    }, [profile?.candidatActivitySector]);

    const jobChange = async (jobval) => {
        let JobArr = "" as any;

        JobArr = jobval.value;
        setData({ ...data, candidatJob: JobArr });
        changeJobSelection(JobArr);
    };

    const changeJobSelection = (value) => {
        setData((prev) => ({ ...prev, ["candidatJob"]: value }));
    };

    const handleChange = (selectedOption) => {
        let arr = [];

        selectedOption.map((el) => {
            arr.push(el.value);
        });

        setData({ ...data, candidatLanguages: arr });
    };

    const switchHandle = (checked, id, e) => {
        if (e == "Permis") {
            if (checked === true) {
                setPermis(true);
                setData({ ...data, candidatLicensePermis: true });

            }
            if (checked === false) {
                setPermis(false);
                setData({ ...data, candidatLicensePermis: false });

            }
        }

    };

    const fetchActivitySectors = async () => {
        return await fetch(API_BASE_URL + "fetchAllSectors", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
            },
        })
            .then((resp) => resp.json())
            .then((respData) => respData)
            .catch((err) => err);
    };

    useEffect(() => {
        if (!sectors.length) {
            fetchActivitySectors()
                .then((sectorsData) => {
                    setSectors([...sectorsData.data])
                })
                .catch(err => console.log(err));
        }
        if (sectorOptions.length === 0) {
            const sectorsOps = sectors.map((sector) => {
                return {
                    value: sector.sectorName,
                    label: sector.sectorName,
                    color: "#FF8B00",
                };
            })

            setSectorOptions([...sectorsOps]);
        }
    }, [sectors]);

    useEffect(() => {
        const wex = workExperience.filter((workex) => {
            return (
                workex.period != "" &&
                workex.location != "" &&
                workex.workDoneSample != ""
            );
        });
        setData((prev) => ({ ...prev, ["candidatExperienceDetails"]: wex }));
        setData((prev) => ({ ...prev, ["candidatSkills"]: profile?.candidatSkills || null }))
    }, [workExperience]);

    const onFormTableDataChange = (event: any, index: any) => {
        const { name, value } = event.target
        let updatedData = [...workExperience]
        updatedData[index][name] = value
        setWorkExperience([...updatedData]);
    }

    const onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        updateCandidat(data)
            .then((response) => {
                if (response.status) {
                    notifyCandidatEditSuccess();
                    setTimeout(() => {
                        navigate(path);
                    }, 2000);
                } else {
                    toast.error("Candidat Change Failed!");
                }
            })
            .catch((err) => {
                console.log(err);
                notifyCandidatEditError();
            });
    }

    const updateCandidat = async (updatedData: any) => {
        let headers = {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
        };
        return await fetch(API_BASE_URL + `editCandidat?_id=${params.id}`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(updatedData),
        })
            .then((reD) => reD.json())
            .then((resD) => resD)
            .catch((err) => err);
    };

    if (!profile) {
        return null
    }

    return (
        <>
            <Toaster
                position="top-right"
                reverseOrder={false}
                containerStyle={{ zIndex: "9999" }}
            />

            <form className="form" onSubmit={onFormSubmit}>
                <div className="tw-bg-white tw-rounded-xl tw-shadow-lg tw-flex tw-justify-between tw-my-4 tw-p-4">
                    <Link to="/candidates">
                        <button
                            type="button"
                            className="btn tw-flex tw-items-center tw-space-x-2"
                        >
                            <img
                                alt="back button"
                                title="Back to Candidates List"
                                src={require("../../images/return.svg").default}
                            />
                            <h2 className="card-Leads mb-0">Edit Profile: {profile.candidatName}</h2>
                        </button>
                    </Link>

                    <div className="tw-flex tw-justify-end tw-items-center tw-space-x-2">
                        <Link to={path} style={{ textDecoration: "none" }}>
                            <button
                                className="btn tw-flex tw-space-x-2 tw-items-center tw-text-red-500 tw-border-[1px] tw-bg-white tw-rounded-full tw-px-4 tw-border-red-600 hover:tw-shadow-lg hover:tw-text-red-600"
                                type="button"
                            >
                                <img
                                    className="tw-w-6 tw-h-6"
                                    src={require("../../images/multiply.svg").default}
                                />

                                <p className="tw-font-semibold">Cancel</p>
                            </button>
                        </Link>

                        <button
                            className="btn tw-flex tw-items-center tw-text-white tw-border-[1px] tw-bg-[#489767] tw-rounded-full hover:tw-shadow-lg hover:tw-text-white tw-space-x-2"
                            type="submit"
                        >
                            <img
                                src={require("../../images/savebtn.svg").default}
                            />

                            <span className="tw-font-semibold">Save Profile</span>
                        </button>
                    </div>
                </div>

                <div className="tw-bg-white tw-rounded-xl tw-shadow-lg tw-flex tw-justify-between tw-my-4 tw-p-4">
                    <div className="tw-relative tw-flex tw-space-x-4 tw-items-center tw-w-full">
                        <div className="tw-flex tw-w-1/2  tw-flex-col tw-space-y-2">
                            <div className="tw-flex tw-flex-col tw-justify-center">
                                <label className="tw-font-semibold tw-text-[#333333] tw-text-center">
                                    Candidate Name
                                </label>
                                <input
                                    defaultValue={profile.candidatName}
                                    className="form-control"
                                    name="candidatName"
                                    onChange={onFormDataChange}
                                />
                            </div>

                            <div className="tw-flex tw-flex-col">
                                <label className="tw-font-semibold tw-flex tw-space-x-2 tw-text-[#333333] tw-justify-center tw-items-center">
                                    Candidate Age
                                </label>
                                <input
                                    defaultValue={profile.candidatAge + " years"}
                                    name="candidatAge"
                                    className="form-control"
                                    onChange={onFormDataChange}
                                />
                            </div>
                        </div>

                        <div
                            className="tw-absolute tw-right-0 tw-px-8 tw-py-2 tw-rounded-full tw-cursor-pointer"
                            style={{ backgroundColor: statusBgColor[profile.candidatStatus] }}
                        >
                            <p
                                className="tw-font-bold tw-text-lg"
                                style={{ color: statusTextColor[profile.candidatStatus] }}
                            >
                                {profile.candidatStatus}
                            </p>
                        </div>
                    </div>
                </div>

                <CandidateDetailsEditForm
                    profile={profile}
                    handleSectorChange={handleSectorChange}
                    jobChange={jobChange}
                    onFormDataChange={onFormDataChange}
                    handleChange={handleChange}
                    Permis={Permis}
                    switchHandle={switchHandle}
                    sectorOptions={sectorOptions}
                    jobOptions={jobOptions}
                    workExperience={workExperience}
                    setWorkExperience={setWorkExperience}
                    onFormTableDataChange={onFormTableDataChange}
                    setPeriod={setPeriod}
                    period={period}
                    location={location}
                    setLocation={setLocation}
                    setWorkDoneSample={setWorkDoneSample}
                    workDoneSample={workDoneSample}
                    data={data}
                    setData={setData}
                />

                <div className="tw-flex tw-rounded-xl tw-shadow-lg tw-bg-white tw-p-5 tw-flex-wrap tw-my-4">
                    {JSON.stringify(profile).includes(
                        JSON.stringify(profile.candidatContract)
                    ) ? (
                        <CandidateContract profile={profile} onFormDataChange={onContractFormChange} />
                    ) : (
                        <div className="tw-w-full tw-flex tw-justify-center tw-items-center">
                            <ErrorLoader />
                            <p className="tw-mb-0 tw-ErrorSearchBox">
                                No Contract Details Available for this Candidate! Please add a New Contract.
                            </p>
                        </div>
                    )}
                </div>

                <div className="tw-bg-white tw-rounded-xl tw-shadow-lg tw-flex tw-justify-end tw-my-4 tw-p-4">
                    <div className="tw-flex tw-justify-end tw-items-center tw-space-x-2">
                        <Link to={path} style={{ textDecoration: "none" }}>
                            <button
                                className="btn tw-flex tw-space-x-2 tw-items-center tw-text-red-500 tw-border-[1px] tw-bg-white tw-rounded-full tw-px-4 tw-border-red-600 hover:tw-shadow-lg hover:tw-text-red-600"
                                type="button"
                            >
                                <img
                                    className="tw-w-6 tw-h-6"
                                    src={require("../../images/multiply.svg").default}
                                />

                                <p className="tw-font-semibold">Cancel</p>
                            </button>
                        </Link>

                        <button
                            className="btn tw-flex tw-items-center tw-text-white tw-border-[1px] tw-bg-[#489767] tw-rounded-full hover:tw-shadow-lg hover:tw-text-white tw-space-x-2"
                            type="submit"
                        >
                            <img
                                src={require("../../images/savebtn.svg").default}
                            />

                            <span className="tw-font-semibold">Save Profile</span>
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default EditCandidateProfile;

const statusBgColor = {
    "New": "#E5EEFF",
    "No Answer": "#FFE1E1",
    "Contacted": "#6FCB94",
    "Interested": "#FEF1E1",
    "Collecting Docs": "#ECF4FF",
    "Pre-Selected": "#ECF4FF",
    "In-Progress": "#DDFFEA",
    "To-Do": "#E5EEFF",
    "Hired": "#DDFFEA",
    "Fired": "#FFE1E1",
    "Denied": "#FFE1E1",
    "Finished": "#ECECEC",
    "Archived": "#FFE1E1",
    "Dead Lead": "#ECECEC",
};

const statusTextColor = {
    "New": "#3F76E2",
    "NEW": "#3F76E2",
    "No Answer": "#E21B1B",
    "Contacted": "#FFFFFF",
    "Interested": "#FE8700",
    "Collecting Docs": "#31435B",
    "Pre-Selected": "#31435B",
    "In-Progress": "#489767",
    "To-Do": "#3F76E2",
    "Hired": "#489767",
    "Fired": "#E21B1B",
    "Denied": "#E21B1B",
    "Finished": "#000000",
    "Archived": "#E21B1B",
    "Dead Lead": "#000000",
}

const colourStyles: StylesConfig<ColourOption, true> = {
    control: (styles) => ({ ...styles, backgroundColor: "white", padding: '5px', borderRadius: '20px' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = chroma(data.color);
        return {
            ...styles,
            backgroundColor: isDisabled
                ? undefined
                : isSelected
                    ? data.color
                    : isFocused
                        ? color.alpha(0.1).css()
                        : undefined,
            color: isDisabled
                ? "#ccc"
                : isSelected
                    ? chroma.contrast(color, "white") > 2
                        ? "white"
                        : "black"
                    : data.color,
            cursor: isDisabled ? "not-allowed" : "default",

            ":active": {
                ...styles[":active"],
                backgroundColor: !isDisabled
                    ? isSelected
                        ? data.color
                        : color.alpha(0.3).css()
                    : undefined,
            },
        };
    },
    multiValue: (styles, { data }) => {
        const color = chroma(data.color);
        return {
            ...styles,
            backgroundColor: color.alpha(0.1).css(),
        };
    },
    multiValueLabel: (styles, { data }) => ({
        ...styles,
        color: data.color,
    }),
    multiValueRemove: (styles, { data }) => ({
        ...styles,
        color: data.color,
        ":hover": {
            backgroundColor: data.color,
            color: "white",
        },
    }),
};

const CandidateDetailsEditForm = ({ profile, handleSectorChange, jobChange, onFormDataChange, handleChange, Permis, switchHandle, sectorOptions, jobOptions, workExperience, setWorkExperience, onFormTableDataChange, setPeriod, period, location, setLocation, setWorkDoneSample, workDoneSample, data, setData }) => {
    const [ownersOptions, setOwnersOptions] = useState([]);
    const [startDate, setStartDate] = useState(profile.candidatStartDate);

    const convertDateFormat = (date) => {
        const [day, month, year] = date.split("-");
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (ownersOptions.length === 0) {
            fetchOwners()
                .then((ownersData) => {
                    const ownersOps = ownersData.data.map((owner) => {
                        return {
                            value: owner.username,
                            label: owner.username,
                            color: "#FF8B00",
                        };
                    })

                    setOwnersOptions([...ownersOps]);
                })
                .catch(err => console.log(err));

        }
    }, [ownersOptions]);

    const fetchOwners = async () => {
        return await fetch(API_BASE_URL + `allusers`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
            },
        })
            .then((red) => red.json())
            .then((resData) => resData)
            .catch((err) => err);
    };

    return (
        <div className="tw-p-6 tw-bg-white tw-rounded-xl tw-shadow-lg ">
            <div className="tw-flex tw-flex-wrap tw-space-y-4 tw-justify-between tw-items-center">
                <div className="tw-flex tw-w-full tw-space-x-4 tw-justify-between tw-text-center tw-items-center">
                    <div className="tw-flex-1">
                        <label className="tw-font-semibold tw-m-0">Email Address</label>
                        <input
                            name="candidatEmail"
                            defaultValue={profile.candidatEmail}
                            onChange={onFormDataChange}
                            className="tw-w-full tw-px-[10px] tw-py-[10px] tw-border-[1px] tw-rounded-full"
                            placeholder="Enter Candidate Email"
                        />
                    </div>

                    <div className="tw-flex-1">
                        <label className="tw-font-semibold tw-m-0">Phone Number</label>
                        <input
                            type="tel"
                            defaultValue={profile.candidatPhone}
                            onChange={onFormDataChange}
                            name="candidatPhone"
                            className="tw-w-full tw-px-[10px] tw-py-[10px] tw-border-[1px] tw-rounded-full"
                            placeholder="Use international format"
                        />
                    </div>

                    <div className="tw-flex-1">
                        <label className="tw-font-semibold tw-m-0">
                            Candidate Start Date
                        </label>
                        <input
                            type="date"
                            className="tw-w-full tw-px-[10px] tw-py-[10px] tw-border-[1px] tw-rounded-full tw-cursor-pointer tw-appearance-none"
                            name="candidatStartDate"
                            defaultValue={convertDateFormat(startDate)}
                            onChange={onFormDataChange}
                            onClick={(e) => e.currentTarget.showPicker()}
                        />
                    </div>
                </div>

                <div className="tw-flex tw-w-full tw-space-x-4 tw-justify-between tw-text-center tw-items-center">
                    <div className="tw-flex tw-flex-col tw-flex-1 tw-space-y-4">
                        <label className="tw-font-semibold tw-m-0">License Drive</label>
                        <span>
                            <Switch
                                onChange={switchHandle}
                                checked={Permis}
                                defaultValue={Permis}
                                id="Permis"
                                height={20}
                                width={48}
                            />
                        </span>
                    </div>

                    <div className="tw-flex-1">
                        <label className="tw-font-semibold tw-m-0">Sector of Activity</label>
                        <Select
                            className="basic-multi-select"
                            classNamePrefix="select"
                            closeMenuOnSelect={true}
                            placeholder="Select A Sector"
                            options={sectorOptions}
                            onChange={handleSectorChange}
                            defaultValue={{
                                value: profile.candidatActivitySector,
                                label: profile.candidatActivitySector,
                                color: "#FE8700",
                            }}
                            styles={colourStyles}
                        />
                    </div>

                    <div className="tw-flex-1">
                        <label className="tw-font-semibold tw-m-0">Profession</label>
                        <Select
                            name="jobName"
                            closeMenuOnSelect={true}
                            placeholder="Select A Profession"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            defaultValue={{
                                label: profile.candidatJob,
                                value: profile.candidatJob,
                                color: "#FE8700",
                            }}
                            onChange={jobChange}
                            options={jobOptions}
                            styles={colourStyles}
                        />
                    </div>
                </div>

                <div className="tw-flex tw-w-full tw-space-x-4 tw-justify-between tw-items-center tw-text-center">
                    <div className="tw-flex-1">
                        <label className="tw-font-semibold tw-m-0">Owner Of The Lead</label>
                        <Select
                            options={ownersOptions}
                            defaultValue={{
                                value: profile.enteredBy,
                                label: profile.enteredBy,
                                color: "#FE8700",
                            }}
                            isClearable={false}
                            onChange={(e: any) => setData({ ...data, "enteredBy": e.value })}
                            name="enteredBy"
                            styles={colourStyles}
                            className="basic-multi-select tw-w-full"
                            classNamePrefix="select"
                            closeMenuOnSelect={true}
                            placeholder="Select Owner"
                        />
                    </div>

                    <div className="tw-flex-1">
                        <label className="tw-font-semibold tw-m-0">Candidate's Languages</label>
                        <Select
                            name="candidatLanguages"
                            closeMenuOnSelect={false}
                            isMulti
                            placeholder="Select Languages"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={handleChange}
                            options={colourOptions}
                            styles={colourStyles}
                            defaultValue={profile.candidatLanguages.map((el) => {
                                return {
                                    value: el,
                                    label: el,
                                    color: "#FE8700",
                                };
                            })}
                        />
                    </div>
                </div>

                <div className="tw-flex tw-flex-col tw-w-full">
                    <label className="tw-font-semibold tw-m-0">
                        Candidate Address
                    </label>
                    <input
                        name="candidatAddress"
                        defaultValue={profile.candidatAddress}
                        onChange={onFormDataChange}
                        className="tw-w-full tw-px-[10px] tw-py-[10px] tw-border-[1px] tw-rounded-full"
                        placeholder="Enter Candidate Address"
                    />
                </div>
            </div>

            {/* Candidate Experience */}
            <div className="tw-pt-4 tw-w-full">
                <p className="label tw-font-semibold">Edit Work Experience of the candidate:</p>
                <table className="table table-bordered tw-text-center border-dark tw-rounded-lg tw-shadow-sm">
                    <thead>
                        <tr>
                            <th scope="col">
                                Example Period: Jan 2020 to Jan 2021
                            </th>
                            <th scope="col">Workplace Example: Paris</th>
                            <th scope="col">
                                Job/Work carried out Example: Facadier Insulator
                            </th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {workExperience.length > 0 ?
                            workExperience.map((workex, index) => (
                                <tr key={index}>
                                    <td>
                                        <input
                                            type="text"
                                            value={workex.period}
                                            name="period"
                                            className="form-control"
                                            placeholder="Years"
                                            onChange={(event) => onFormTableDataChange(event, index)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            value={workex.location}
                                            name="location"
                                            className="form-control"
                                            placeholder="Work Location"
                                            onChange={(event) => onFormTableDataChange(event, index)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            value={workex.workDoneSample}
                                            name="workDoneSample"
                                            className="form-control"
                                            placeholder="Work Done Sample"
                                            onChange={(event) => onFormTableDataChange(event, index)}
                                        />
                                    </td>
                                    <td className="d-flex">
                                        <button type="button"
                                            onClick={() => {
                                                let newArr = []
                                                newArr = workExperience.filter((fl, i) => i !== index)
                                                setWorkExperience([...newArr])
                                            }} className="btn experience-action-button">  <img alt="..." src={require("../../images/Deletebucket.svg").default} /></button>
                                        <button type="button" onClick={() => {
                                            let newArr = [...workExperience]
                                            newArr.push({ period: "", location: "", workDoneSample: "" })
                                            setWorkExperience([...newArr])
                                        }} className="btn experience-action-button"><svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14m-7 7V5" />
                                            </svg>
                                        </button>
                                    </td>
                                </tr>
                            )) :
                            <tr >
                                <td>
                                    <input
                                        type="text"
                                        value={period}
                                        name="period"
                                        className="form-control"
                                        placeholder="Years"
                                        onChange={(event) => setPeriod(event.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        value={location}
                                        name="location"
                                        className="form-control"
                                        placeholder="Work Location"
                                        onChange={(event) => setLocation(event.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        value={workDoneSample}
                                        name="workDoneSample"
                                        className="form-control"
                                        placeholder="Work Done Sample"
                                        onChange={(event) => setWorkDoneSample(event.target.value)}
                                    />
                                </td>
                                <td className="d-flex">
                                    <button type="button" onClick={() => {
                                        let newArr = []
                                        newArr.push({ period: period, location: location, workDoneSample: workDoneSample })
                                        setWorkExperience([...newArr])
                                    }} className="btn"><svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14m-7 7V5" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

            {
                profile.candidatArchived && profile.candidatArchived.reason ?
                    <div className="tw-rounded-xl tw-bg-white tw-my-4">
                        <div className="tw-flex tw-justify-between">
                            <p className="tw-text-xl tw-text-black tw-font-bold">Reason for <span className="tw-text-red-600">{profile.candidatStatus}</span>:</p>
                        </div>
                        <textarea
                            id="skills"
                            name="reasonArchived"
                            className="form-control tw-border-black focus-visible:tw-outline-none"
                            defaultValue={profile.candidatArchived.reason}
                            onChange={onFormDataChange}
                            rows={4}
                        >
                        </textarea>
                    </div>
                    : null}

            <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-4 tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-md tw-p-4">
                <div className="tw-w-full">
                    <h5 className="tw-font-bold">Edit Skills/Notes</h5>
                </div>

                <div className="tw-grid tw-grid-cols tw-grid-cols-2 tw-gap-4 tw-w-full">
                    {data?.candidatSkills && data.candidatSkills.includes("[") ? (
                        JSON.parse(data.candidatSkills).length > 0 &&
                        JSON.parse(data.candidatSkills).map((el, index) => {
                            const rawContent = el.value && el.value.getCurrentContent ? convertToRaw(el.value.getCurrentContent()) : null;
                            const contentState = rawContent ? convertFromRaw(rawContent) : ContentState.createFromText('');
                            const editorState = EditorState.createWithContent(contentState);
                            return (
                                <div key={index} className="tw-flex tw-flex-col">
                                    <label className="tw-text-gray-800 tw-block tw-mb-1">Note Date: {el?.date}</label>

                                    <Editor
                                        defaultEditorState={EditorState.createWithContent(
                                            ContentState.createFromBlockArray(convertFromHTML(typeof el === "string" ? el : el.value || ""))
                                        )}
                                        toolbarClassName="shadow"
                                        wrapperClassName="tw-border-[1px] tw-border-gray-300"
                                        onEditorStateChange={(newState) => {
                                            const updatedSkills = JSON.parse(data?.candidatSkills);

                                            // Ensure `el` is an object before modifying it
                                            if (typeof updatedSkills[index] === "string") {
                                                updatedSkills[index] = {
                                                    value: updatedSkills[index], // Preserve the original string
                                                    editorValue: newState,
                                                };
                                            } else {
                                                updatedSkills[index].editorValue = newState;
                                                updatedSkills[index].value = draftToHtml(convertToRaw(newState.getCurrentContent()));
                                            }

                                            setData({
                                                ...data,
                                                candidatSkills: JSON.stringify(updatedSkills),
                                            });
                                        }}
                                    />
                                </div>
                            );
                        })
                    ) :
                        null
                    }
                </div>

                {data?.candidatSkills && data.candidatSkills.includes("[") ? (
                    <div className="tw-flex tw-justify-end tw-gap-4 tw-mt-4">
                        <button
                            type="button"
                            className={`tw-bg-white tw-text-gray-600 tw-border tw-border-gray-400 tw-px-4 tw-py-2 tw-rounded-full ${JSON.parse(data.candidatSkills).length > 0 ? 'hover:tw-shadow-xl' : ''}`}
                            disabled={JSON.parse(data.candidatSkills).length === 0}
                            onClick={() => {
                                let arr = JSON.parse(data.candidatSkills).filter(
                                    (_, i) => i !== JSON.parse(data.candidatSkills).length - 1
                                );
                                if (JSON.parse(data.candidatSkills).length > 0) {
                                    setData({
                                        ...data,
                                        candidatSkills: JSON.stringify([...arr]),
                                    });
                                }
                            }}
                        >
                            {
                                JSON.parse(data.candidatSkills).length > 0 ? "Delete Last Note" : "No Notes to Delete"
                            }
                        </button>
                        <button
                            type="button"
                            className="tw-bg-blue-600 tw-text-white tw-px-4 tw-py-2 tw-rounded-full hover:tw-shadow-xl"
                            onClick={() => {
                                if (JSON.parse(data.candidatSkills).length !== 0) {
                                    setData({
                                        ...data,
                                        candidatSkills: JSON.stringify([
                                            ...JSON.parse(data.candidatSkills),
                                            { editorValue: "", value: "", date: format(new Date(), 'dd/MM/yyyy') },
                                        ]),
                                    });
                                } else {
                                    setData({
                                        ...data,
                                        candidatSkills: JSON.stringify([
                                            { editorValue: "", value: "", date: format(new Date(), 'dd/MM/yyyy') },
                                        ]),
                                    });
                                }
                            }}
                        >
                            Add New Note
                        </button>
                    </div>
                ) : <div className="tw-flex tw-justify-end tw-gap-4 tw-mt-4">
                    <button
                        type="button"
                        className="tw-bg-blue-600 tw-text-white tw-px-4 tw-py-2 tw-rounded-full hover:tw-shadow-xl"
                        onClick={() => {
                            if (data.candidatSkills.length !== 0) {
                                setData({
                                    ...data,
                                    candidatSkills: JSON.stringify([
                                        data.candidatSkills,
                                        { editorValue: "", value: "", date: format(new Date(), 'dd/MM/yyyy') },
                                    ]),
                                });
                            } else {
                                setData({
                                    ...data,
                                    candidatSkills: JSON.stringify([
                                        { editorValue: "", value: "", date: format(new Date(), 'dd/MM/yyyy') },
                                    ]),
                                });
                            }
                        }}
                    >
                        Add New Note
                    </button>
                </div>}
            </div>
        </div>
    );
};

function CandidateContract({ profile, onFormDataChange }) {
    const [contract_date, setcontract_date] = useState() as any;
    const [debutMissionDate, setdebutMissionDate] = useState() as any;
    const [fin_mision, setfin_mision] = useState() as any;
    const [GetMonth, setMonth] = useState() as any;
    const [GetMonth2, setMonth2] = useState() as any;
    const [GetMonth3, setMonth3] = useState() as any;

    useEffect(() => {
        if (profile.candidatContract) {
            let tempdate = new Date(profile.candidatContract.contract_date);
            setMonth(tempdate.getMonth() + 1);
            let NewCdate = [
                tempdate.getDate(),
                GetMonth,
                tempdate.getFullYear(),
            ].join("-");
            setcontract_date(NewCdate);

            let tempdate2 = new Date(profile.candidatContract.debutMissionDate);
            setMonth2(tempdate2.getMonth() + 1);
            let NewMDate = [
                tempdate2.getDate(),
                GetMonth2,
                tempdate2.getFullYear(),
            ].join("-");
            setdebutMissionDate(NewMDate);

            let tempdate3 = new Date(profile.candidatContract.fin_mision);
            setMonth3(tempdate3.getMonth() + 1);
            let FormatNewDate = [
                tempdate3.getDate(),
                GetMonth3,
                tempdate3.getFullYear(),
            ].join("-");
            setfin_mision(FormatNewDate);
        }
    });

    if (!profile.candidatContract?.lieu_mission) {
        return null
    }
    return (
        <>
            <div className="col-4 d-grid text-start">
                <label className="PDFFormlabel">Lieu_Mission</label>
                <input
                    className="form-control inputStylingForView"
                    onChange={onFormDataChange}
                    name="lieu_mission"
                    defaultValue={
                        profile?.candidatContract
                            ? profile.candidatContract?.lieu_mission
                                ? profile?.candidatContract?.lieu_mission
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Lieu_Mission"
                />
            </div>
            <div className="col-4  d-grid text-start">
                <label className="PDFFormlabel">Durée_Mission</label>
                <input
                    className="form-control inputStylingForView"
                    onChange={onFormDataChange}
                    name="duree_mission"
                    defaultValue={
                        profile?.candidatContract
                            ? profile.candidatContract?.duree_mission
                                ? profile.candidatContract.duree_mission
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Durée_Mission"
                />
            </div>
            <div className="col-4  d-grid text-start">
                <label className="PDFFormlabel  d-flex align-items-start ">
                    Durée_Hebdomadaire_Mission
                </label>
                <input
                    className="form-control inputStylingForView"
                    onChange={onFormDataChange}
                    name="duree_hebdomadaire_mission"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.duree_hebdomadaire_mission
                                ? profile.candidatContract.duree_hebdomadaire_mission
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Durée_Hebdomadaire_Mission"
                />
            </div>
            <div className="col-4  d-grid text-start">
                <label className="PDFFormlabel">Candidate_Job</label>
                <input
                    className="form-control inputStylingForView"
                    onChange={onFormDataChange}
                    name="candidatJob"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.candidatJob
                                ? profile.candidatContract.candidatJob
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Candidate_Job"
                />
            </div>
            <div className="col-4  d-grid text-start">
                <label className="PDFFormlabel">CMP_CANDIDATE</label>
                <input
                    className="form-control inputStylingForView"
                    onChange={onFormDataChange}
                    name="cmp_candidat"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.cmp_candidat
                                ? profile.candidatContract.cmp_candidat
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ CMP_CANDIDATE"
                />
            </div>
            <div className="col-4  d-grid text-start">
                <label className="PDFFormlabel">Contract_date</label>
                <input
                    className="form-control inputStylingForView"
                    type=""
                    name="contract_date"
                    onChange={onFormDataChange}
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.contract_date
                                ? contract_date
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Contract_date"
                />
            </div>
            <div className="col-4  d-grid text-start">
                <label className="PDFFormlabel d-flex align-items-start ">
                    Company_Contact_Name
                </label>

                <input
                    className="form-control inputStylingForView"
                    onChange={onFormDataChange}
                    name="company_contact_name"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.company_contact_name
                                ? profile.candidatContract.company_contact_name
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Company_Contact_Name"
                />
            </div>
            <div className="col-4  d-grid text-start">
                <label className="PDFFormlabel">NR_INREG</label>
                <input
                    className="form-control inputStylingForView"
                    onChange={onFormDataChange}
                    name="nr_inreg"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.nr_inreg
                                ? profile.candidatContract.nr_inreg
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ NR_INREG"
                />
            </div>
            <div className="col-4  d-grid text-start">
                <label className="PDFFormlabel">SERIE_ID</label>
                <input
                    className="form-control inputStylingForView"
                    onChange={onFormDataChange}
                    name="serie_id"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.serie_id
                                ? profile.candidatContract.serie_id
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ SERIE_ID"
                />
            </div>

            <div className="col-4 d-grid text-start">
                <label className="PDFFormlabel">Candidate_Adress</label>
                <input
                    className="form-control inputStylingForView"
                    onChange={onFormDataChange}
                    name="candidatAddress"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.candidatAddress
                                ? profile.candidatContract.candidatAddress
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Candidate_Adress"
                />
            </div>
            <div className="col-4  d-grid text-start">
                <label className="PDFFormlabel">Company_Siret</label>
                <input
                    className="form-control inputStylingForView"
                    onChange={onFormDataChange}
                    name="company_siret"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.company_siret
                                ? profile.candidatContract.company_siret
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Company_Siret"
                />
            </div>

            <div className="col-4  d-grid ">
                <label className="PDFFormlabel">Numero TF Candidat</label>
                <input
                    className="form-control inputStyling"
                    name="numeroTFCandidat"
                    onChange={onFormDataChange}

                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.numeroTFCandidat
                                ? profile.candidatContract.numeroTFCandidat
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Numero TF Candidat"
                />
            </div>
            <div className="col-4  d-grid ">
                <label className="PDFFormlabel">Company Vat</label>
                <input
                    className="form-control inputStyling"

                    onChange={onFormDataChange}
                    name="companyVat"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.companyVat
                                ? profile.candidatContract.companyVat
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Company Vat"
                />
            </div>
            <div className="col-4  d-grid ">
                <label className="PDFFormlabel">Salaire Brut</label>
                <input
                    className="form-control inputStyling"

                    onChange={onFormDataChange}
                    name="salaireBrut"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.salaireBrut
                                ? profile.candidatContract.salaireBrut
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Salaire Brut"
                />
            </div>

            <div className="col-4  d-grid ">
                <label className="PDFFormlabel">Salaire Net</label>
                <input
                    className="form-control inputStyling"

                    onChange={onFormDataChange}
                    name="salaireNet"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.salaireNet
                                ? profile.candidatContract.salaireNet
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Salaire_Net"
                />
            </div>
            <div className="col-4  d-grid ">
                <label className="PDFFormlabel">Diurna Total Par Jour</label>
                <input
                    className="form-control inputStyling"
                    onChange={onFormDataChange}
                    name="diurnaTotalParJour"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.diurnaTotalParJour
                                ? profile.candidatContract.diurnaTotalParJour
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Diurna Total Par Jour"
                />
            </div>
            <div className="col-4  d-grid ">
                <label className="PDFFormlabel">Debut Mision (Date)</label>
                <input
                    className="form-control inputStyling"
                    type=""
                    name="debutMissionDate"
                    onChange={onFormDataChange}
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.debutMissionDate
                                ? debutMissionDate
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Debut Mision Date"
                />
            </div>

            <div className="col-4  d-grid ">
                <label className="PDFFormlabel">Heure Par Semaine</label>
                <input
                    className="form-control inputStyling"
                    name="heurePerSemaine"
                    onChange={onFormDataChange}

                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.heurePerSemaine
                                ? profile.candidatContract.heurePerSemaine
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Heure Par Semaine"
                />
            </div>
            <div className="col-4  d-grid ">
                <label className="PDFFormlabel">Duree Hebdomadaire</label>
                <input
                    className="form-control inputStyling"
                    name="duree_hebdomadaire"
                    onChange={onFormDataChange}

                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.duree_hebdomadaire
                                ? profile.candidatContract.duree_hebdomadaire
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ Duree Hebdomadaire"
                />
            </div>
            <div className="col-4  d-grid">
                <label className="PDFFormlabel">indemnisation jour</label>
                <input
                    className="form-control inputStyling"
                    name="indemnisation_jour"
                    onChange={onFormDataChange}

                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.indemnisationJour
                                ? profile.candidatContract.indemnisationJour
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ indemnisation jour"
                />
            </div>
            <div className="col-4  d-grid ">
                <label className="PDFFormlabel">Fin Mision</label>
                <input
                    className="form-control inputStyling"
                    type=""

                    name="fin_mision"
                    onChange={onFormDataChange}
                    defaultValue={
                        profile.candidatContract
                            ? profile.fin_mision != ""
                                ? fin_mision
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ indemnisation jour"
                />
            </div>
            <div className="col-4  d-grid ">
                <label className="PDFFormlabel">Hébergement de l'employé (hosting)</label>
                <input
                    className="form-control inputStyling"
                    type=""
                    name="employee_hosting"
                    onChange={onFormDataChange}
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract?.employee_hosting
                                ? profile.candidatContract?.employee_hosting
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎ indemnisation jour"
                />
            </div>

            <div className="col-12 px-1  d-grid text-start">
                <label className="PDFFormlabel">Company_Adress</label>
                <textarea
                    className="TextAreaPage form-control"
                    onChange={onFormDataChange}

                    name="companyAddress"
                    defaultValue={
                        profile.candidatContract
                            ? profile.candidatContract.companyAddress
                                ? profile.candidatContract.companyAddress
                                : "input Not Available!"
                            : "input Not Available!"
                    }
                    placeholder="‎ ‎ ‎Company_Adress"
                ></textarea>
            </div>
        </>
    );
}

const notifyCandidatEditSuccess = () => toast.success(
    "Candidate Updated Successfully! View Candidate in the Candidates List."
);

const notifyCandidatEditError = () => toast.error("Cannot Edit Candidat! Please Try Again.");
